// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  resourcebaseurl: 'https://kandidaten.matchpoint-campus.de',
  restapiurl: 'https://kandidaten.matchpoint-campus.de/api/v1',
  apitoken: 'SgLxLVRKcbj33P6vA6SeUN2cGZHw7jUEqCHYkc2Zum7wB45L',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
